<template>
  <div>
    <div class="yazdirtable Aski" v-for="d in data">

      <div>
        <el-row :gutter="24" class="mb-3">
          <el-col :span="12" class="text-left">
            <img src="https://cdn.mudu.pro/Design/yapifen.svg" class="YpImage">
          </el-col>
          <el-col :span="12" class="text-right">
            <img src="https://cdn.mudu.pro/Design/jetusta.svg" class="YpImage">
          </el-col>
        </el-row>
        <table class="table table-bordered table-lg">
          <thead>
          <tr>
            <th colspan="6" class="text-center" style="font-size: 18px !important;">SERVİS FORMU</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <small class="d-block">Talep No</small>
              {{ d.id }}
            </td>
            <td>
              <small class="d-block">Talep Tarihi</small>
              {{ d.tarih }}
            </td>
            <td>
              <small class="d-block">Ad Soyad</small>
              {{ d.AdSoyad }}
            </td>
            <td>
              <small class="d-block">Telefon</small>
              {{ d.Telefon }}
            </td>
            <td>
              <small class="d-block">Adres</small>
              {{ d.Adres }}
            </td>
            <td>
              <small class="d-block">Bölge</small>
              {{ d.Bolge }}
            </td>
          </tr>
          <tr>
            <td colspan="6">
              <small class="d-block">Açıklama</small>
              {{ d.Aciklama }}
            </td>
          </tr>
          <tr>
            <td colspan="6">
              <small class="d-block">Servis Notu</small>
              <div style="height: 180px"></div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <small class="d-block">Ödeme Şekli</small>
              Nakit / Kredi Kartı / Havale
            </td>
            <td colspan="3">
              <small class="d-block">Ödeme Yapan</small>
              <br>
            </td>
            <td colspan="1">
              <small class="d-block">Ödenecek Tutar</small>
              <br>
            </td>
          </tr>
          <tr>
            <td colspan="6">
              <small class="d-block">İŞİ TESLİM ALAN</small>
              <small class="d-block">Ad Soyad / Telefon / İmza</small>
              <br><br><br>
            </td>

          </tr>
          </tbody>
        </table>

      </div>
      <div class="kesimcizgi"></div>
      <el-row :gutter="24" class="mb-3">
        <el-col :span="12" class="text-left">
          <img src="https://cdn.mudu.pro/Design/yapifen.svg" class="YpImage">
        </el-col>
        <el-col :span="12" class="text-right">
          <img src="https://cdn.mudu.pro/Design/jetusta.svg" class="YpImage">
        </el-col>
      </el-row>
      <table class="table table-bordered table-lg">
        <thead>
        <tr>
          <th colspan="6" class="text-center" style="font-size: 18px !important;">SERVİS TESLİM TUTANAĞI</th>
        </tr>
        <tr>
          <td>
            <small class="d-block">Talep No</small>
            {{ d.id }}
          </td>
          <td>
            <small class="d-block">Talep Tarihi</small>
            {{ d.tarih }}
          </td>
          <td>
            <small class="d-block">Ad Soyad</small>
            {{ d.AdSoyad }}
          </td>
          <td>
            <small class="d-block">Telefon</small>
            {{ d.Telefon }}
          </td>
          <td>
            <small class="d-block">Adres</small>
            {{ d.Adres }}
          </td>
          <td>
            <small class="d-block">Bölge</small>
            {{ d.Bolge }}
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <small class="d-block">Açıklama</small>
            {{ d.Aciklama }}
            <div style="height: 80px"></div>
          </td>
        </tr>
        <tr>
          <td colspan="4">
            <small class="d-block">Tutar (Yazı ile)</small>
            <br>
            <br>
          </td>
          <td colspan="2">
            <small class="d-block">Tutar (Rakam ile)</small>
            <br>
            <br>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <small class="d-block">İŞİ TESLİM EDEN</small>
            <br>
            <br>
          </td>
          <td colspan="2">
            <small class="d-block">ÖDEME TÜRÜ</small>
            Nakit / Kredi Kartı / Havale
            <br>
            <br>
          </td>
          <td>
            <small class="d-block">TESLİM ALAN İMZA</small>
            <br>
            <br>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <small class="d-block"><b>Servis Telefon:</b> 0552 420 6838</small>
            <small class="d-block"><b>Muhasebe Telefon:</b> 0541 915 6838</small>
          </td>
          <td colspan="4">
            <small class="d-block"><b>Hesap Sahibi:</b> Mudu Arge Yazılım Teknolojileri San.Tic.Ltd.Şti.</small>
            <small class="d-block"><b>Banka:</b> Albaraka Türk Katılım Bankası</small>
            <small class="d-block"><b>IBAN:</b> TR84 0020 3000 0893 5405 0000 02</small>
          </td>
        </tr>
        </thead>
        <tbody>
        </tbody>
      </table>

      <div class="sayfasonu"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data']
}
</script>

<style scoped>
.yazdirtable {
  display: block;
}

.YpImage {
  max-height: 80px;
  max-width: 50%;
}

.yazdirtable table.table-lg tr td, table.yazdirtable.table-lg tr th {
  font-size: 12px !important;
}

.kesimcizgi {
  width: 100%;
  border-bottom: 1px dashed #000;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>




// WEBPACK FOOTER //
// src/pages/JetUsta/Comp/juTalepForm.vue